<template>
    <div class="o-page__content u-pt-small">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-xl-12">
                    <h1 class="u-h3">Report</h1>
                    <div style="display: inline-block; float: right; margin-top: -40px;">
                        <el-date-picker
                            v-model="daterange"
                            type="daterange"
                            format="dd MMM yyyy"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Start"
                            @change="fetch"
                            :picker-options="datePickerOptions"
                            end-placeholder="End">
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="row u-mt-medium" v-if="employee">
                <div class="col-12">
                    <el-button size="small" icon="el-icon-back" @click="$router.push({name: 'report'})">Back</el-button>
                    <article class="c-stage u-mt-small">
                        <div class="c-stage__header o-media u-justify-start">
                            <div class="c-stage__icon o-media__img" style="width: 60px;height: 60px;background-size: cover;" v-bind:style="{ 'background-image': 'url(' + employee.image + ')' }"></div>
                            <div class="c-stage__header-title o-media__body">
                                <h6 class="u-mb-zero">{{employee.name.toUpperCase()}}</h6>
                                <p class="u-text-xsmall u-text-mute">{{employee.outlet_name}} | {{employee.position_name}}</p>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
            <div class="row u-mt-medium" v-else-if="outlet">
                <div class="col-12">
                    <el-button size="small" icon="el-icon-back" @click="$router.push({name: 'report'})">Back</el-button>
                    <article class="c-stage u-mt-small">
                        <div class="c-stage__header o-media u-justify-start">
                            <div class="c-stage__header-title o-media__body">
                                <h6 class="u-mb-zero">{{outlet.name.toUpperCase()}}</h6>
                                <p class="u-text-xsmall u-text-mute">{{outlet.regional}}, {{outlet.branch}} | {{outlet.lat}}, {{outlet.lng}}</p>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <vue-good-table v-loading="loading"
                        :columns="columns"
                        :rows="rows"
                        :select-options="{ 
                            enabled: true,
                            selectOnCheckboxOnly: true,
                            disableSelectInfo: true
                        }"
                        :pagination-options="{
                            enabled: true
                        }">

                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'average'">
                                <el-rate
                                    :value="parseFloat(props.row.average)"
                                    disabled
                                    show-score
                                    text-color="#ff9900"
                                    score-template="{value} star">
                                </el-rate>
                            </span>
                            <span v-else-if="props.column.field == 'rating'">
                                <span v-for="(item, id) in JSON.parse(props.row.rating)" :key="id">
                                    <el-tag type="info" size="mini">
                                        {{ item.name }}
                                        <el-rate
                                            :value="item.star"
                                            disabled
                                            show-score
                                            text-color="#ff9900"
                                            score-template="{value} star">
                                        </el-rate>
                                    </el-tag>
                                </span>
                                <!-- <div v-for="(item, idx) in JSON.parse(props.row.rating)" :key="idx">
                                    <div v-if="item.type=='STAR'">
                                        {{ item.aspect_name }} : {{ item.rate }} {{ jsonParse(item.suggestions) }}
                                    </div>
                                    <div v-else>
                                        {{ item.aspect_name }}: {{ item.note }}
                                    </div>
                                </div> -->
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table';
    import api from '@/api/ratings'
    import employee from '@/api/employees'
    import outlet from '@/api/outlets'
    import moment from 'moment'
    import { mapActions } from 'vuex';

    export default {
        components: {
            'vue-good-table':VueGoodTable
        },
        data() {
            return {
                datePickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                daterange: [],
                columns: [
                    {
                        label: 'Tanggal',
                        field: this.dateField
                    },
                    {
                        label: 'Nama Penilai',
                        field: 'author_name'
                    },
                    {
                        label: 'Nilai Rata-rata',
                        field: 'average',
                        width: '200px'
                    },
                    {
                        label: 'Penilaian',
                        field: 'rating',
                        width: '200px'
                    },
                    {
                        label: 'Note',
                        field: 'note'
                    }
                ],
                rows: [],
                loading: false,
                employee: null,
                outlet: null
            }
        },
        mounted () {
            let end = new Date()
            var start = moment(start).subtract(1, 'months')._d;
            // end = new Date(end)
            this.daterange = [start, end];
            
            if(!this.$route.params.code){
                this.$route.push({name: 'report'})
            }

            this.fetch()

            if(this.$route.query.facility) {
                this.fetchOutlet()
            } else {
                this.fetchEmployee()
            }
        },
        methods: {
            jsonParse(data){
                if(data){
                    var string = '('
                    var datax = JSON.parse(data);
                    datax.forEach( (element,idx) => {
                        string += element
                        if(idx != datax.length-1){
                            string += ', '
                        }
                    });
                    string += ')'
                    return string
                } else {
                    return ''
                }
            },
            dateField(rowObj) {
                return moment(rowObj.created_at).format('dddd, DD MMMM YYYY / H:mm')
            },
            ...mapActions([
                'logout'
            ]),
            fetchEmployee() {
                var self = this
                employee.getOne(this.$route.params.code)
                .then(function (response) {
                    self.employee = response.data.data
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchOutlet() {
                var self = this
                outlet.getOne(this.$route.params.code)
                .then(function (response) {
                    self.outlet = response.data.data
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetch() {
                this.loading = true
                var self = this
                api.getDetail(this.$route.params.code, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'), this.$route.query.facility?1:'')
                .then(function (response) {
                    if(response.data.data.length > 0){
                        self.rows = response.data.data
                        // self.totalRecords = 100
                        self.loading = false
                    } else {
                        self.loading = false
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>